module.exports = __webpack_public_path__ + "static/media/Illustration_Student.5c5ef70e.svg";